import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, FormGroup, Col, Row } from 'reactstrap';
import Modal from '@material-ui/core/Modal';
import ModalMessage from '../../shared/components/Modal';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { DatePicker, KeyboardDatePicker, MuiPickersUtilsProvider, TimePicker } from "@material-ui/pickers";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import "moment/locale/es";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import MCADAailableTimesList from './MCADAailableTimesList';
import MCADAailableTimesListActions from './MCADAailableTimesListActions';
import Spinner from 'react-bootstrap/Spinner';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { withStyles } from "@material-ui/core/styles";
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import BlockIcon from '@material-ui/icons/Block';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ModalPhaseServiceInAditional from './ModalPhaseServiceInAditional';
import LaunchIcon from '@material-ui/icons/Launch';


const MedicalCheckbox = withStyles({
    root: {
        '&$checked': {
            color: '#4ce1b6',
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },
    },
});

const CHIP_MAX_WIDTH = 100;
const CHIP_ICON_WIDTH = 30;

const EllipsisText = props => {
    const { children } = props;

    return (
        <div
            style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: CHIP_MAX_WIDTH - CHIP_ICON_WIDTH
            }}
        >
            {children}
        </div>
    );
};

class ModalChangeAppointmentDate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: this.props.date,
            errors: {},
            isLoading: false,
            availableTimes: [],
            confirmedCitas: [],
            openAlert: false,
            modalAlert: { title: '', color: '', message: '' },
            activitySelected: null,
            costumer_data: null,
            costumer: null,
            plans: [],
            plan: null,
            activitiesPriceList: [],
            activitiesAppointment: [],
            appointmentPhase: null,
            openModalAppointmentPhase: false,
            cantAppointments: 0,
            typeAgendaList: [],
            typeAgenda: null
        };
    };

    componentDidMount = () => {

    }

    cleanData = () => {
        this.props.closeModal();
    }

    handlerActivity = (activity) => {
        this.setState({ activitySelected: activity }, () => {
            console.log(this.state.activitySelected);
        });
    }

    verifyAvailableTimes = async (dateFilter, serviceFilter) => {
        if (dateFilter != null && dateFilter != undefined && serviceFilter != undefined && serviceFilter != null) {
            this.setState({ isLoading: true });
            await fetch(process.env.REACT_APP_PUBLIC_URL + 'cita/buscar-disponibilidad', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify({ fecha: dateFilter, id_servicio: serviceFilter.id_servicio })
            }).then(response => {
                return response.json();
            }).then(data => {
                this.setState({ availableTimes: data, isLoading: false });
            }).catch((error) => {
                this.setState({ isLoading: false });
                console.error('Error:', error);
                this.setState({
                    openAlert: true, modalAlert: {
                        color: 'danger',
                        title: "Error de Filtros",
                        message: "Ha ocurrido un error buscando las Jornadas Disponibles del dia seleccionado"
                    }
                });
            });
        }
    }

    handlerConfirmedCitas = (value) => {
        let repeat = this.props.activitiesAppointment.some(ac => ac.id_servicio == this.state.activitySelected.id_servicio && this.state.activitySelected.requiere_multicitas != true);
        if (!repeat) {
            value.id_servicio = this.state.activitySelected.id_servicio;
            value.detalle_servicio = this.state.activitiesPriceList.find(ser => ser.id_servicio == this.state.activitySelected.id_servicio);
            value.detalle_regimen = {
                tercero: this.state.costumer_data,
                plan: this.state.plans.find(pl => pl.id_plan == this.state.plan)
            }
            value.nombre_fase = null;
            if (value.detalle_servicio.requiere_multicitas != true) {
                this.props.handlerConfirmedAdditionalAppointments(value);
            }
            else {
                if (this.props.activitiesAppointment.some(ac => ac.id_servicio == this.state.activitySelected.id_servicio)) {
                    this.setState({ appointmentPhase: value }, () => {
                        let appointmentsNecesaryForService = this.validateAppointmentsNecesaryForService(value.detalle_servicio);
                        this.setState({ openModalAppointmentPhase: true, cantAppointments: appointmentsNecesaryForService });
                    });
                }
                else {
                    this.setState({ openAlert: true, modalAlert: { color: 'danger', title: "Servicio Multicitas", message: "Solo se puede parametrizar un servicio de Multicitas" } });
                }
            }
        }
        else {
            this.setState({ openAlert: true, modalAlert: { color: 'danger', title: "Error de Confirmación", message: "El Servicio ya ha sido elegido en la Parametrización de la Cita" } });
            return;
        }
    }

    validateAppointmentsNecesaryForService(service) {
        let cantidad = parseInt(service.limite_multicitas) - 1;
        let citasConfirmadas = this.props.confirmedAdditionalAppointments.filter(ser => ser.id_servicio == service.id_servicio);
        cantidad = parseInt(cantidad) - parseInt(citasConfirmadas.length);
        return cantidad;
    }

    validateAgendaConfirmedSome = (id_jornada, id_agenda) => {
        let finded = this.props.confirmedAdditionalAppointments.some(con => con.id_jornada == id_jornada && con.id_agenda == id_agenda);
        return finded;
    }

    validateCalendarConfirmed = (id_jornada) => {
        let confirmed = "";
        let finded = this.props.confirmedAdditionalAppointments.find(con => con.id_jornada == id_jornada);
        if (finded != null && finded != undefined) {
            confirmed = moment(finded.start).format("DD/MM/YYYY h:mm a");
            confirmed = finded.nombre_profesional.toString() + " - " + confirmed.toString() + ": ";
        }
        return confirmed;
    }

    validateCalendarConfirmedSome = (id_jornada) => {
        let finded = this.props.confirmedAdditionalAppointments.some(con => con.id_jornada == id_jornada);
        return finded;
    }

    handlerThird_contract = async (third) => {
        this.setState({
            costumer: third.id_tercero,
            costumer_data: third,
            plans: [],
            plan: null,
            activitiesPriceList: [],
            activitySelected: null,
            availableTimes: []
        });
        let contractId = parseInt(third.id_contrato);
        await this.loadPlansFromContract(contractId);
    }

    loadPlansFromContract = async (id) => {
        this.setState({
            activitiesPriceList: [],
            activitySelected: null,
            availableTimes: []
        }, () => {
            let data = { id_contrato: id };
            fetch(process.env.REACT_APP_PUBLIC_URL + 'plan/consultar_x_contrato', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(data)
            }).then(response => {
                return response.json();
            }).then(data => {
                if (data.existe) {
                    this.setState({ plans: data.contenido }, () => console.log("ESTADOPLANES", this.state.plans));
                } else {
                    this.setState({ plans: [] })
                }
            }).catch((error) => {
                console.error('Error:', error);
            });
        });
    }

    loadActivitiesPriceList = async (tercero, plan) => {
        this.setState({ plan: plan });
        var data = { id_tercero: tercero, id_plan: plan };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'serter/consultar', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify(data)
        }).then(response => {
            return response.json();
        }).then(data => {
            if (data.existe) {
                this.setState({ activitiesPriceList: data.contenido[0].servicios.servicios });
            } else {
                this.setState({ activitiesPriceList: [] });
            }
        }).catch((error) => {
            console.error('Error:', error);
        });
    }

    unmountAppointmentConfirmed = (appointment) => {
        let confirmedNewsAppointment = this.props.confirmedAdditionalAppointments.filter(confAppointment => confAppointment.id_jornada != appointment.id_jornada);
        this.props.completeHandlerConfirmedAddionalAppointments(confirmedNewsAppointment);
    }

    modalMessageLimitExceded = () => {
        this.setState({ openAlert: true, modalAlert: { color: 'danger', title: 'Limite Excedido', message: 'No puede agendar mas este servicio, agregar otra cita superaria el limite de fases del servicio' } });
    }

    sendaDataMultiAppointment = async () => {
        let serviceMultiPhase = this.props.activitiesAppointment.find(dataSer => dataSer.requiere_multicitas == true);
        this.setState({
            costumer: this.props.actualAppointmentClient.id_tercero,
            costumer_data: this.props.actualAppointmentClient,
            plans: [],
            plan: null,
            activitiesPriceList: [],
            activitySelected: null,
            availableTimes: []
        }, () => {
            let contractId = parseInt(this.props.actualAppointmentClient.id_contrato);
            this.loadPlansFromContract(contractId).then(() => {
                this.setState({ plan: this.props.actualAppointmentPlan }, () => {
                    this.loadActivitiesPriceList(this.props.actualAppointmentClient.id_tercero, this.props.actualAppointmentPlan).then(() => {
                        this.setState({ activitySelected: serviceMultiPhase }, () => {
                            this.verifyAvailableTimes(this.state.date, serviceMultiPhase);
                        });
                    });
                });
            });
        });
    }

    validateHandlerAdditionalPhase = (appointmentPhase) => {
        try {
            if (this.props.actualAppointmentClient.id_tercero == this.state.costumer_data.id_tercero && this.props.actualAppointmentPlan == this.state.plan) {
                this.props.handlerConfirmedAdditionalAppointments(appointmentPhase);
                this.setState({ openModalAppointmentPhase: false, appointmentPhase: null });
            }
            else {
                this.setState({
                    openAlert: true, modalAlert: {
                        color: 'danger',
                        title: 'Entidad Diferente',
                        message: 'Este servicio se va prestar por la entidad ' + this.props.actualAppointmentClient.nombre + ' con el plan ' + this.props.actualAppointmentPlanDetails.nombre.toUpperCase() + ' ,si desea cambiar la Entidad debe hacerlo en la Parametrización Principal'
                    }
                });
            }
        }
        catch (err) {
            console.log(err);
        }
    }

    render() {

        const ListAilable = () => {
            return (<MCADAailableTimesList
                reactTableData={this.state.availableTimes}
                ReactTableActions={MCADAailableTimesListActions}
                updating={false}
                handlerConfirmedCitas={this.handlerConfirmedCitas}
                validateAgendaConfirmedSome={this.validateAgendaConfirmedSome}
            />);
        }

        return (
            <>
                <Modal
                    open={this.props.openModalAdditionalAppointment}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    style={{ zIndex: 1000 }}
                    disableEnforceFocus={true}
                >
                    <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                        <h4 className="bold-text">Cita Adicional</h4>
                        <label>Seleccione el Cliente con su Regimen, el Plan, la Fecha y el Servicio para ir Filtrando la Disponibilidad</label>
                        <Row>
                            <Col md={4}>
                                <FormControl
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }, shrink: true
                                    }}
                                    style={{ width: '100%', paddingRight: 10 }}
                                    error={this.state.errors.hasOwnProperty("costumer") ? this.state.errors.costumer !== "" : false}
                                >
                                    <InputLabel shrink={true} required id="demo-simple-select-label">Cliente</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={this.state.costumer_data}
                                        onChange={(event) => {
                                            this.handlerThird_contract(event.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("costumer") ? this.state.errors.costumer !== "" : false}
                                    >
                                        <MenuItem className="material-form__option" value={null}>Ninguno</MenuItem>
                                        {this.props.serter.map((third) => {
                                            //console.log(third);
                                            return <MenuItem className="material-form__option" key={third.id_tercero} value={third}>{third.nombre_tercero_concatenado}</MenuItem>
                                        })}
                                    </Select>
                                    <FormHelperText>{this.state.errors.costumer}</FormHelperText>
                                </FormControl>
                            </Col>
                            <Col md={4}>
                                <FormControl
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' }, shrink: true
                                    }}
                                    style={{ width: '100%' }}
                                    error={this.state.errors.hasOwnProperty("plan") ? this.state.errors.plan !== "" : false}
                                >
                                    <InputLabel shrink={true} required id="demo-simple-select-label">Plan</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={this.state.plan}
                                        onChange={(event) => {
                                            this.loadActivitiesPriceList(this.state.costumer, event.target.value);
                                        }}
                                        error={this.state.errors.hasOwnProperty("plan") ? this.state.errors.plan !== "" : false}
                                    >
                                        <MenuItem className="material-form__option" value={null}>Ninguno</MenuItem>
                                        {this.state.plans.map((plan) => {
                                            return <MenuItem className="material-form__option" key={plan.id_plan} value={plan.id_plan}>{plan.nombre}</MenuItem>
                                        })}
                                    </Select>
                                    <FormHelperText>{this.state.errors.plan}</FormHelperText>
                                </FormControl>
                            </Col>
                            <Col md={4}>
                                <FormControl
                                    style={{ width: 300, position: 'relative', left: 10 }}
                                >
                                    <Autocomplete
                                        id="tags-standard"
                                        size="small"
                                        options={this.state.activitiesPriceList}
                                        disableCloseOnSelect
                                        value={this.state.activitySelected}
                                        onChange={(event, value) => {
                                            this.handlerActivity(value);
                                            this.verifyAvailableTimes(this.state.date, value);
                                        }}
                                        getOptionLabel={(activity) => activity.codigo + " " + activity.servicios}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                className="medical-material-form__field"
                                                InputLabelProps={{
                                                    style: { color: '#646777' }, shrink: true
                                                }}
                                                style={{ maxWidth: "80%", overflow: "hidden" }}
                                                variant="standard"
                                                label="Servicios a prestar"
                                                placeholder=""
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Col>
                        </Row>

                        {
                            this.props.activitiesAppointment.some(dataSer => dataSer.requiere_multicitas == true) ?
                                <Row>
                                    <Col md={4}>
                                        <TextField
                                            className="medical-material-form__field"
                                            style={{ width: '100%' }}
                                            id="document-number-standard-required"
                                            label="Servicio Multifase"
                                            value={this.props.activitiesAppointment.find(dataSer => dataSer.requiere_multicitas == true).servicios}
                                            disabled={true}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <TextField
                                            className="medical-material-form__field"
                                            style={{ width: '100%' }}
                                            id="document-number-standard-required"
                                            label="Nombre de la Fase de Apertura"
                                            value={this.props.nameInitialPhase}
                                            onChange={(e) => {
                                                this.props.changeNameInitialPhase(e.target.value);
                                            }}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Button
                                            style={{ marginRight: 10, marginLeft: 10 }}
                                            variant="contained"
                                            color='primary'
                                            onClick={() => {
                                                this.sendaDataMultiAppointment();
                                            }}
                                        >
                                            Cargar Datos de Cita de Apertura
                                        </Button>
                                    </Col>
                                </Row> : null
                        }
                        <Row>
                            <Col md={4}>
                                <br />
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <DatePicker
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                style: { color: '#646777' }, shrink: true
                                            }}
                                            variant="static"
                                            label="Fecha"
                                            autoOk={true}
                                            disableToolbar={true}
                                            value={this.state.date}
                                            onChange={(date) => {
                                                this.setState({ date: date });
                                                this.verifyAvailableTimes(date, this.state.activitySelected);
                                            }}
                                            format="DD/MM/yyyy"
                                            animateYearScrolling
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>

                                {
                                    /*
                                    <FormControl
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        style: { color: '#646777' },
                                        shrink: true,
                                    }}
                                    style={{ width: '100%' }}
                                >
                                    <InputLabel shrink={true} id="services-reassign-label">Tipo de Agenda</InputLabel>
                                    <Select
                                        labelId="select-type-agenda"
                                        id="select-type-agenda"
                                        value={""}
                                        onChange={(event) => {
                                            this.setState({ typeAgenda: event.target.value })
                                        }}
                                    >
                                        {this.state.typeAgendaList.map((typeA, index) => {
                                            return <MenuItem key={typeA.id_atencion} value={typeA.id_atencion}>{typeA.atencion}</MenuItem>
                                        })}
                                    </Select>
                                    <FormHelperText>{this.state.errors.type_agenda}</FormHelperText>
                                </FormControl>    
                                    */
                                }

                                <div style={{ fontSize: 12, maxHeight: 150, width: '95%', overflowY: 'scroll' }}>

                                    <b>Información de Citas Adicionales:</b>
                                    <br />
                                    {this.props.confirmedAdditionalAppointments.map((confCita) => {
                                        return (
                                            <>
                                                <span>
                                                    <Tooltip title="Quitar">
                                                        <IconButton aria-label="unmount service appointment" component="span"
                                                            onClick={() => {
                                                                this.unmountAppointmentConfirmed(confCita);
                                                            }}>
                                                            <BlockIcon style={{ color: '#C20D0D' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                    {this.validateCalendarConfirmedSome(confCita.id_jornada) ? <>
                                                        <FontAwesomeIcon style={{ color: '#fd7e14' }} icon={faClock} />
                                                        <b style={{ color: '#fd7e14' }}>{this.validateCalendarConfirmed(confCita.id_jornada)}</b></> : null}
                                                    {confCita.detalle_servicio.codigo + "-" + confCita.detalle_servicio.servicios + "  "}
                                                </span>
                                                <br />
                                            </>
                                        );
                                    })}
                                </div>

                            </Col>
                            <Col md={8}>
                                {
                                    this.state.isLoading == false ? <>
                                        {this.state.availableTimes.length > 0 ? <ListAilable /> : <b>
                                            <br /><br /><br />
                                            No hay disponibilidad con los Filtros seleccionados
                                        </b>}
                                    </>
                                        :
                                        <div className="text-center">
                                            <Spinner animation="border" variant="success" />
                                        </div>
                                }
                            </Col>
                        </Row>

                        <div style={{ marginTop: 10, display: 'flex', marginTop: 10, justifyContent: 'flex-end' }}>
                            <Button
                                style={{ marginRight: 10, marginLeft: 10 }}
                                variant="contained"
                                onClick={() => {
                                    this.cleanData();
                                }}
                            >
                                Cerrar
                            </Button>
                        </div>
                    </div>
                </Modal>

                {
                    this.state.openModalAppointmentPhase ?
                        <ModalPhaseServiceInAditional
                            activityMultiphase={this.state.activitySelected}
                            appointmentPhase={this.state.appointmentPhase}
                            opened={this.state.openModalAppointmentPhase}
                            closeModal={() => {
                                this.setState({ openModalAppointmentPhase: false, appointmentPhase: null });
                            }}
                            validateHandlerAdditionalPhase={this.validateHandlerAdditionalPhase}
                            cantAppointments={this.state.cantAppointments}
                            modalMessageLimitExceded={() => this.modalMessageLimitExceded()}
                        /> : null
                }


                {
                    this.state.openAlert ?
                        <ModalMessage
                            color={this.state.modalAlert.color}
                            title={this.state.modalAlert.title}
                            message={this.state.modalAlert.message}
                            modal={this.state.openAlert}
                            toggle={() => {
                                this.setState({ openAlert: false, modalAlert: { color: '', title: '', message: '' } });
                            }}
                            onOk={() => {
                                if (this.state.modalAlert.color == "warning") {
                                    this.setState({ openAlert: false, modalAlert: { color: '', title: '', message: '' } }, () => {
                                        this.confirmedNewCitas();
                                    });
                                }
                                else if (this.state.modalAlert.color == "success") {
                                    this.setState({ openAlert: false, modalAlert: { color: '', title: '', message: '' } }, () => {
                                        this.props.reloadAgenda();
                                    });
                                }
                                else {
                                    this.setState({ openAlert: false, modalAlert: { color: '', title: '', message: '' } });
                                }
                            }}
                        /> : null
                }
            </>);
    }
}

export default ModalChangeAppointmentDate;
